import { adminConstants } from '../constant/admin-constant';
import { alertActions } from './alert-actions';
import { history } from '../../helper/history';
import { festivalService } from '../../services/festival';
export const festivalActions = {
    getFestivalsPagination,
    getFestivalComments,
    updateComment,
    updateCommentData,
    getMusicDirectorsForFestival,
    getFestival,
    storeFestival,
    editFestival,
    getFestivalMusicDirectors,
    getFestivalAdjudicators,
    storeFestivalMusicDirector,
    storeFestivalAdjudicator,
    getFestivalMusicDirector,
    getFestivalAdjudicator,
    deleteFestival,
    deleteFestivalMusicDirector,
    deleteFestivalAdjudicator,
    editFestivalMusicDirector,
    editFestivalAdjudicator,
    createSheetForFestival,
    getFestivalsAllMusicDirectorsPagination,
    getFestivalsAllAdjudicatorsPagination,
    getPricePerAdjudicationValue,
    storeMDMedia,
    getMDMedia,
    deleteMDMedia,
};

function deleteFestivalMusicDirector(festivalId, id){
    return dispatch => {
        dispatch(request());
        festivalService.deleteFestivalMusicDirector(festivalId, id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);

                
                //history.push('/Admin/Companies');
                //history.push('/Admin/Companies');
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_REQUEST } }
    function success(response)   { return { type: adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_FAILURE, payload:error } }
}

function deleteFestivalAdjudicator(festivalId, id){
    return dispatch => {
        dispatch(request());
        festivalService.deleteFestivalAdjudicator(festivalId, id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);

                
                //history.push('/Admin/Companies');
                //history.push('/Admin/Companies');
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.DELETE_FESTIVAL_ADJUDICATOR_REQUEST } }
    function success(response)   { return { type: adminConstants.DELETE_FESTIVAL_ADJUDICATOR_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.DELETE_FESTIVAL_ADJUDICATOR_FAILURE, payload:error } }
}

function deleteFestival(id){
    return dispatch => {
        dispatch(request());
        festivalService.deleteFestival(id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                     history.go(0);
                }, 1500);

               
                //history.push('/Admin/Companies');
                //history.push('/Admin/Companies');
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.DELETE_FESTIVAL_REQUEST } }
    function success(response)   { return { type: adminConstants.DELETE_FESTIVAL_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.DELETE_FESTIVAL_FAILURE, payload:error } }
}
function getFestival(id){
    return dispatch => {
        dispatch(request());
        festivalService.getFestival(id)
        .then(
            festival => {
                dispatch(success(festival));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_REQUEST } }
    function success(festival)   { return { type: adminConstants.GET_FESTIVAL_SUCCESS, payload:festival } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_FAILURE, payload:error } }
}
function getFestivalCommentsWorking (festivalId){
    return dispatch => {
        dispatch(request());
        festivalService.getFestival(festivalId)
        .then(
            festival => {
                dispatch(success(festival));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_REQUEST } }
    function success(festival)   { return { type: adminConstants.GET_FESTIVAL_SUCCESS, payload:festival } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_FAILURE, payload:error } }
}
function getFestivalComments (festivalId, page){
    return dispatch => {
        dispatch(request());
        festivalService.getFestivalComments(festivalId, page)
        .then(
            festival => {
                dispatch(success(festival));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_COMMENTS_REQUEST } }
    function success(festival)   { return { type: adminConstants.GET_FESTIVAL_COMMENTS_SUCCESS, payload:festival } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_COMMENTS_FAILURE, payload:error } }
}
function updateComment(info, id){
    return dispatch => {
        dispatch(request());
        festivalService.updateComment(info, id)
        .then(
            response => {
                dispatch(success(response));
                // history.push('/Admin/'+info.festival_id+'/Comments');
                dispatch(alertActions.success(response.message));
                window.location.reload();
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_REQUEST } }
    function success()   { return { type: adminConstants.EDIT_FESTIVAL_SUCCESS } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_FAILURE, payload:error } }
}
function updateCommentData(info, id){
    return dispatch => {
        dispatch(request());
        return festivalService.updateCommentData(info, id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // window.location.reload();
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_REQUEST } }
    function success()   { return { type: adminConstants.EDIT_FESTIVAL_SUCCESS } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_FAILURE, payload:error } }
}
function getMusicDirectorsForFestival (festivalId){
    return dispatch => {
        dispatch(request());
        festivalService.getMusicDirectorsForFestival(festivalId)
        .then(
            festival => {
                dispatch(success(festival));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST } }
    function success(festival)   { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS, payload:festival } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE, payload:error } }
}


function getFestivalsPagination(page, filter, sort, companyId, pageSize){
    return dispatch => {
        dispatch(request())
        festivalService.getFestivalsPagination(page, filter, sort, companyId, pageSize)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {

                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.PAGINATION_FESTIVAL_REQUEST } }
    function success(response)   { return { type: adminConstants.PAGINATION_FESTIVAL_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.PAGINATION_FESTIVAL_FAILURE, payload:error } }
}

function storeFestival(festivalData, companyId){
    return dispatch => {
        dispatch(request());
        festivalService.storeFestival(festivalData, companyId)
        .then(
            response => {
                dispatch(success(response));
                history.push('/Admin/Festivals');
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.STORE_FESTIVAL_REQUEST } }
    function success()   { return { type: adminConstants.STORE_FESTIVAL_SUCCESS } }
    function failure(error) { return { type: adminConstants.STORE_FESTIVAL_FAILURE, payload:error } }
}


function editFestival(id, festivalData){
    return dispatch => {
        dispatch(request());
        festivalService.editFestival(id, festivalData)
        .then(
            response => {
                dispatch(success(response));
                history.push('/Admin/Festivals');
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_REQUEST } }
    function success()   { return { type: adminConstants.EDIT_FESTIVAL_SUCCESS } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_FAILURE, payload:error } }
}

function getFestivalMusicDirectors(id){
    return dispatch => {
        dispatch(request());
        festivalService.getFestivalMusicDirectors(id)
        .then(
            festivalMusicDirector => {
                dispatch(success(festivalMusicDirector));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST } }
    function success(festivalMusicDirector)   { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS, payload:festivalMusicDirector } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE, payload:error } }
}


function getFestivalAdjudicators(id){
    return dispatch => {
        dispatch(request());
        festivalService.getFestivalAdjudicators(id)
        .then(
            festivalAdjudicator => {
                dispatch(success(festivalAdjudicator));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_ADJUDICATORS_REQUEST } }
    function success(festivalAdjudicator)   { return { type: adminConstants.GET_FESTIVAL_ADJUDICATORS_SUCCESS, payload:festivalAdjudicator } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_ADJUDICATORS_FAILURE, payload:error } }
}


function getFestivalMusicDirector(id){
    return dispatch => {
        dispatch(request());
        festivalService.getFestivalMusicDirector(id)
        .then(
            musicDirector => {
                dispatch(success(musicDirector));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_REQUEST } }
    function success(musicDirector)   { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_SUCCESS, payload:musicDirector } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_FAILURE, payload:error } }
}


function getFestivalAdjudicator(id){
    return dispatch => {
        dispatch(request());
        festivalService.getFestivalAdjudicator(id)
        .then(
            adjudicator => {
                dispatch(success(adjudicator));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_FESTIVAL_ADJUDICATOR_REQUEST } }
    function success(adjudicator)   { return { type: adminConstants.GET_FESTIVAL_ADJUDICATOR_SUCCESS, payload:adjudicator } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_ADJUDICATOR_FAILURE, payload:error } }
}


function storeFestivalMusicDirector(festivalMusicDirectorData, festivalId){
    return dispatch => {
        dispatch(request());
        festivalService.storeFestivalMusicDirector(festivalMusicDirectorData, festivalId)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);
                
                // history.push('/Admin/Company/'+companyId+'/users');
                // location.reload();
                
                // history.go(0);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_REQUEST } }
    function success(response)   { return { type: adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS } }
    function failure(error) { return { type: adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_FAILURE, payload:error } }
}


function storeFestivalAdjudicator(festivalAdjudicatorData, festivalId){
    return dispatch => {
        dispatch(request());
        festivalService.storeFestivalAdjudicator(festivalAdjudicatorData, festivalId)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);
                
                // history.push('/Admin/Company/'+companyId+'/users');
                // location.reload();
                
                // history.go(0);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.STORE_FESTIVAL_ADJUDICATOR_REQUEST } }
    function success(response)   { return { type: adminConstants.STORE_FESTIVAL_ADJUDICATOR_SUCCESS } }
    function failure(error) { return { type: adminConstants.STORE_FESTIVAL_ADJUDICATOR_FAILURE, payload:error } }
}

function editFestivalMusicDirector(festivalUserData, festivalId, id){

    return dispatch => {
        dispatch(request());
        festivalService.editFestivalMusicDirector(festivalUserData, festivalId, id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);
                // history.push('/Admin/Companies');
                
            },
            error => {
                console.log('error', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_REQUEST } }
    function success(response)   { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_FAILURE, payload:error } }
}

function editFestivalAdjudicator(festivalAdjudicatorData, festivalId, id){

    return dispatch => {
        dispatch(request());
        festivalService.editFestivalAdjudicator(festivalAdjudicatorData, festivalId, id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                    history.go(0);
                }, 1500);
                // history.push('/Admin/Companies');
                
            },
            error => {
                console.log('error', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_ADJUDICATOR_REQUEST } }
    function success(response)   { return { type: adminConstants.EDIT_FESTIVAL_ADJUDICATOR_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_ADJUDICATOR_FAILURE, payload:error } }
}

function createSheetForFestival(festivalId, type, actionType, templateData, updateAndSend){
    return dispatch => {
        dispatch(request());
        festivalService.createSheetForFestival(festivalId, type, actionType, templateData, updateAndSend)
        .then(
            response => {
                console.log('response', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){ 
                //     history.go(0);
                // }, 1500);
                // history.push('/Admin/Companies');
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_REQUEST } }
    function success(response)   { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_FAILURE, payload:error } }
}


function getFestivalsAllMusicDirectorsPagination(page, filter, sort, companyId, pageSize){
    return dispatch => {
        dispatch(request())
        festivalService.getFestivalsAllMusicDirectorsPagination(page, filter, sort, companyId, pageSize)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_REQUEST } }
    function success(response)   { return { type: adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_FAILURE, payload:error } }
}


function getFestivalsAllAdjudicatorsPagination(page, filter, sort, companyId, pageSize){
    return dispatch => {
        dispatch(request())
        festivalService.getFestivalsAllAdjudicatorsPagination(page, filter, sort, companyId, pageSize)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_REQUEST } }
    function success(response)   { return { type: adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_FAILURE, payload:error } }
}

function getPricePerAdjudicationValue(companyId){
    return dispatch => {
        dispatch(request())
        festivalService.getPricePerAdjudicationValue(companyId)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.GET_PRICE_PER_ADJUDICATION_REQUEST } }
    function success(response)   { return { type: adminConstants.GET_PRICE_PER_ADJUDICATION_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_PRICE_PER_ADJUDICATION_FAILURE, payload:error } }
}

function storeMDMedia(MDId, mediaData) {
    return dispatch => {
        dispatch(request());
        return festivalService.storeMDMedia(MDId, mediaData)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.STORE_MDMEDIA_REQUEST } }
    function success(response)   { return { type: adminConstants.STORE_MDMEDIA_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.STORE_MDMEDIA_FAILURE, payload:error } }
}

function getMDMedia(MDId) {
    return dispatch => {
        dispatch(request());
        festivalService.getMDMedia(MDId)
        .then(
            response => {
                dispatch(success(response));
                
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_MDMEDIA_REQUEST } }
    function success(response)   { return { type: adminConstants.GET_MDMEDIA_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_MDMEDIA_FAILURE, payload:error } }
}

function deleteMDMedia(MediaId) {
    return dispatch => {
        dispatch(request());
        festivalService.deleteMDMedia(MediaId)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.DELETE_MDMEDIA_REQUEST } }
    function success(response)   { return { type: adminConstants.DELETE_MDMEDIA_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.DELETE_MDMEDIA_FAILURE, payload:error } }
}


// WEBPACK FOOTER //
// ./src/redux/actions/festival-action.jsx